import React, { memo } from 'react';
import { Stack, Flex, Image, Box, Text } from '@chakra-ui/react';

import aiIcon from '@/assets/icon/ai-icon.svg';
import { ScreeningAnalysisResult, AlertsAndFollowUpQuestion } from '@/types/AnalysisResult';
import {
  RequirementsMatchSection,
  FollowUpItemsSection,
  StrengthsAndConcernsSection
} from '@/views/Candidate/components';
import { ScreeningType } from '@/types/enums';

interface ScreeningSummarySectionProps {
  screeningType: ScreeningType;
  analysisResult: ScreeningAnalysisResult;

  // Job Interview specific props
  followUpQuestions?: AlertsAndFollowUpQuestion[];
  onUpdateItem?: (index: number, item: AlertsAndFollowUpQuestion | null) => Promise<boolean>;
  followUpItemsRef?: React.RefObject<HTMLDivElement | null>;
}

const ScreeningSummarySection = memo(
  ({
    screeningType,
    analysisResult,
    followUpQuestions,
    onUpdateItem,
    followUpItemsRef
  }: ScreeningSummarySectionProps) => {
    return (
      <Stack gap="12px">
        <Stack>
          <Flex mb="12px">
            <Image src={aiIcon} w="20px" h="20px" alt="AI Overview" />
            <Box color="neutrals.900" fontSize="18px" fontWeight="semibold" ml="8px">
              AI Overview
            </Box>
          </Flex>
          <Text
            id="ai-overview"
            fontSize="16px"
            color="neutrals.700"
            p={0}
            whiteSpace="pre-wrap"
            mb="12px"
          >
            {analysisResult.overview}
          </Text>
        </Stack>
        {screeningType === ScreeningType.JobInterview ? (
          <>
            <RequirementsMatchSection analysisResult={analysisResult} />
            {followUpItemsRef && followUpQuestions && onUpdateItem && (
              <FollowUpItemsSection
                followUpQuestions={followUpQuestions}
                onUpdateItem={onUpdateItem}
                followUpItemsRef={followUpItemsRef}
              />
            )}
          </>
        ) : (
          <StrengthsAndConcernsSection analysisResult={analysisResult} />
        )}
      </Stack>
    );
  }
);

ScreeningSummarySection.displayName = 'ScreeningSummarySection';

export default ScreeningSummarySection;
